/**
 * The format for the eighty_languages and the eigthy_language_names must be the same, i.e.,
 * if 'spanish is on the fifth position on eighty_languages, then its abbreviature on thn_language_names
 * must be on the fifth position too.
 * @ignore
 */
var dict = {
    english: 'en',
    french: 'fr',
    german: 'de',
    italian: 'it',
    portuguese: 'pt',
    polish: 'pl',
    russian: 'ru',
    spanish: 'es',
    catalan: 'ca',
    finnish: 'fi',
    'portuguese br': 'pt',
    greek: 'el',
};
function getLanguageCode(str) {
    return dict[str.toLowerCase()];
}

export { getLanguageCode as g };
